import { NavLink } from "react-router-dom";
import { Home, PlusCircle, CheckCircle, User } from "lucide-react";
import { cn } from "@/lib/utils";
import { useSafeAreaInsets } from "@/hooks/useSafeAreaInsets";

const MobileNav = () => {
  const { bottomPadding } = useSafeAreaInsets();
  
  const navLinks = [
    { to: "/seller/dashboard", icon: Home, label: "Home" },
    { to: "/seller/properties/new", icon: PlusCircle, label: "New Deal" },
    { to: "/seller/properties/active", icon: CheckCircle, label: "Deals" },
    { to: "/seller/profile", icon: User, label: "Account" }
  ];

  return (
    <nav className={cn("fixed bottom-0 left-0 right-0 z-50 bg-[#080c14] border-t border-gray-700 md:hidden", bottomPadding)}>
      <div className="flex justify-around items-center h-14">
        {navLinks.map(link => {
          const IconComponent = link.icon;
          return (
            <NavLink
              key={link.to}
              to={link.to}
              className={({ isActive }) => cn(
                "flex flex-col items-center justify-center flex-1 py-2",
                isActive ? "text-[#ffd700]" : "text-gray-400"
              )}
            >
              <IconComponent className="w-6 h-6" strokeWidth={2} />
              <span className="text-xs mt-1 font-medium">{link.label}</span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileNav;
